<template>
  <v-card :loading="loading">
    <v-card-title class="px-6">
      Payment Method
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="px-6">
      <v-row v-for="(method, i) in billing_methods" :key="i">
        <v-col cols="auto">
          <font-awesome-icon
            :icon="['fab', icon(method)]"
            size="2x"
            v-if="icon(method)"
          ></font-awesome-icon>
          <v-icon size="28" v-else color="secondarytext">credit_card</v-icon>
        </v-col>
        <v-col class="subtitle-1">
          &#8226;&#8226;&#8226;&#8226; &#8226;&#8226;&#8226;&#8226;
          &#8226;&#8226;&#8226;&#8226; {{ method.last4 }}
        </v-col>
        <v-col class="subtitle-1 text-center" v-if="!method.isDefault">
          <v-btn text small color="info" @click="makeDefault(method.id)">
            Set As Default
          </v-btn>
        </v-col>
        <v-spacer class="limited-spacer"></v-spacer>
        <v-col cols="auto">
          <v-btn
            text
            class="light-background"
            small
            color="info"
            @click="showDialog(method)"
          >
            Edit
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn @click="showDialog(null)">Add New Card</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <edit-payment-method
      ref="editPaymentMethod"
      v-on:save="$emit('save')"
    ></edit-payment-method>
    <add-payment-method
      ref="addPaymentMethod"
      v-on:save="$emit('save')"
    ></add-payment-method>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
import EditPaymentMethod from "@/components/billing/EditPaymentMethod";
import AddPaymentMethod from "@/components/billing/AddPaymentMethod";
export default {
  name: "PaymentMethodCard",
  components: { FontAwesomeIcon, EditPaymentMethod, AddPaymentMethod },
  props: { loading: { type: Boolean, default: false } },
  computed: {
    icon() {
      return method => {
        switch (method.type) {
          case "visa":
            return "cc-visa";
          case "mastercard":
            return "cc-mastercard";
          case "discover":
            return "cc-discover";
          case "diners":
            return "cc-diners-club";
          case "jcb":
            return "cc-jcb";
          case "amex":
            return "cc-amex";
        }
        return "";
      };
    },
    ...mapGetters({ billing_methods: "billing/billing_methods" })
  },
  created() {
    library.add(fab);
  },
  methods: {
    showDialog(method) {
      if (method) {
        this.$refs.editPaymentMethod.showDialog(method);
      } else {
        this.$refs.addPaymentMethod.showDialog();
      }
    },
    makeDefault(id) {
      this.saving = true;
      this.$store
        .dispatch("billing/setPaymentMethodDefault", id)
        .then(() => {
          this.$emit("save");

          this.$root.$snackbarSuccess("Default payment method changed");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while changing default payment method."
          );
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
